const LocationPin = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.8008 5.63672C13.6641 5.63672 14.4453 6.15234 14.7812 6.94922M12.5 12.5703V20.4609M16.9883 8.02734C16.9883 10.5078 14.9805 12.5195 12.5 12.5195C10.0195 12.5195 8.01172 10.5078 8.01172 8.02734C8.01172 5.55078 10.0195 3.53906 12.5 3.53906C14.9805 3.53906 16.9883 5.55078 16.9883 8.02734Z"
        stroke="#777A7A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default LocationPin;
